/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export enum TV_INFECTIOUS_ANIMATION_NAMES {
    infect = "infect",
    idle_loop = "idle_loop"
}

export enum TV_INFECTIOUS_SKIN_NAMES {
    L1 = "l1",
    L2 = "l2",
    L3 = "l3",
    L4 = "l4",
    L5 = "l5",
    M1 = "m1",
    M2 = "m2",
    M3 = "m3",
    M4 = "m4",
    M5 = "m5"
}

export enum TV_ANIMATION_NAMES {
    land = "land",
    static = "static",
    reveal = "reveal",
    idle_loop = "idle_loop",
    x_split_left = "x_split_left",
    x_split_middle = "x_split_middle",
    x_split_right = "x_split_right",
    maxwin = "maxwin"
}

export enum TV_SKIN_NAMES {
    M = "m",
    A = "a",
    X = "x",
    sad = "sad",
    max_win = "max_win",
    shoot = "shoot",
    duck = "duck",
    pin = "pin",
    the = "the",
    win = "win",
    tick_1 = "tick_1",
    tick_2 = "tick_2",
    boom = "boom",
    wild = "wild",
    x_split = "x_split",
    infectious = "infectious"
}

export enum SCATTER_TRANSFORM_TEXTURES {
    tick = "S_featureTick",
    tickTick = "S_featureTickTick",
    boom = "S_featureBoom",
    pin = "S_featurePin",
    the = "S_featureThe",
    win = "S_featureWin",
    shoot = "S_featureBonus",
    shootShoot = "S_featureBonus",
    duck = "S_featureDuck",
    wild = "S_wild",
    xSplit = "S_xsplit",
    infectious = "S_xways",
    M = "M",
    A = "A",
    X = "X",
    sad = "noWin",
    max_win = "S_featureMaxWin"
}

export class LonerGameAssets {
    public static BITMAP_FONT_PTW:string = "PTW_NumbersWinCountUp";
    public static BITMAP_FONT_OPENSANS_800:string = "NumbersOpenSans800";
    public static BITMAP_FONT_SSD_MULTIPLIER:string = "NumbersMultiplier";
    public static BITMAP_FONT_SSD_MULTIPLIER_GOLD:string = "NumbersMultiplierGold";
    public static BITMAP_FONT_WIN_COUNT_UP_01:string = "NumbersWinCountUp_1";
    public static BITMAP_FONT_WIN_COUNT_UP_02:string = "NumbersWinCountUp_2";
    public static BITMAP_FONT_WIN_COUNT_UP_03:string = "NumbersWinCountUp_3";
    public static BITMAP_FONT_SSD_GREEN:string = "alarmclockGreen";
    public static BITMAP_FONT_SSD_RED:string = "alarmclockRed";

    public static TV_MESSAGES:string[] = ["tvMessage/tvmessage1","tvMessage/tvmessage2","tvMessage/tvmessage3",
        "tvMessage/tvmessage4","tvMessage/tvmessage5","tvMessage/tvmessage6","tvMessage/tvmessage7",
        "tvMessage/tvmessage8"];
    public static VHS_LOGO:string = "loner_teletext_logo";
    public static TV_MESSAGE_REEL_MASK:string = "tvMessage/reelMask";
    public static BIG_WIN_PRE:string = "Big_Win/BigWins/prebigwin_loner";
    public static MAX_WIN_MULTI:string = "Big_Win/maxWinMulti";

    //Shoot Shoot Duck
    public static SSD_OUTRO_IMAGE:string = "outro/FSoutro_reference";
    public static SSD_INTRO_IMAGE:string = "intro/FSintro";
    public static SSD_FOREGROUND:string = "Top4";
    public static SSD_TOP_BACKGROUND:string = "Top1";
    public static SSD_MIDDLE_BACKGROUND:string = "Top2";
    public static SSD_BOTTOM_BACKGROUND:string = "Top3";
    public static SSD_BULLET:string = "duck_syms/ammo";
    public static SSD_BULLET_BACKGROUND:string = "duck_syms/wooden_part";
    public static SSD_BULLET_EMPTY:string = "duck_syms/ammo_empty";
    public static SSD_MULTIPLIER_HOLDER:string = "fg/bet_way_thing_copy";
    public static SSD_SYMBOL_EXPLOSION:string = "duck_syms/duck_explosion";
    public static SSD_EXPLODED_DUCKS:string[] = ["X", "X2", "X3"];
    public static SSD_CROSSHAIR:string = "crosshair";
    public static SSD_MAX_WIN_TEXT_LEFT:string = "duck_syms/MAX/MAXWIN_left";
    public static SSD_MAX_WIN_TEXT_RIGHT:string = "duck_syms/MAX/MAXWIN_right";
    public static SSD_BULLET_HOLES:string[] = ["duck_syms/bulletHoles/bullet_hole_01", "duck_syms/bulletHoles/bullet_hole_02",
        "duck_syms/bulletHoles/bullet_hole_03", "duck_syms/bulletHoles/bullet_hole_04"];

    //Tick Tick Boom
    public static TTB_GROUND:string = "TickTickBoom/ground";
    public static TTB_CAR:string = "TickTickBoom/van";
    public static TTB_CAR_PIXELS:string = "TickTickBoom/van_pixels";
    public static TTB_CITY_BACKGROUND:string = "TickTickBoom/cityBackground";
    public static TTB_CHURCH_BACKGROUND:string = "TickTickBoom/churchBackground";
    public static TTB_SCHOOL_BACKGROUND:string = "TickTickBoom/schoolBackground";
    public static TTB_SKY_NO_CLOUD:string = "TickTickBoom/sky_no_cloud";
    public static TTB_SKY_CLOUD_01:string = "TickTickBoom/sky_cloud1";
    public static TTB_SKY_CLOUD_02:string = "TickTickBoom/sky_cloud2";
    public static TTB_OFFICE_BUILDING:string = "TickTickBoom/office";
    public static TTB_OFFICE_BUILDING_PIXELS:string = "TickTickBoom/office_pixels";
    public static TTB_OFFICE_BUILDING_HIGHLIGHT:string = "TickTickBoom/office_highlight";
    public static TTB_OFFICE_BUILDING_HIGHLIGHT_PIXELS:string = "TickTickBoom/office_highlight_pixels";
    public static TTB_SCHOOL_BUILDING:string = "TickTickBoom/school";
    public static TTB_SCHOOL_BUILDING_PIXELS:string = "TickTickBoom/school_pixels";
    public static TTB_SCHOOL_BUILDING_HIGHLIGHT:string = "TickTickBoom/school_highlight";
    public static TTB_SCHOOL_BUILDING_HIGHLIGHT_PIXELS:string = "TickTickBoom/school_highlight_pixels";
    public static TTB_CHURCH_BUILDING:string = "TickTickBoom/church";
    public static TTB_CHURCH_BUILDING_PIXELS:string = "TickTickBoom/church_pixels";
    public static TTB_CHURCH_BUILDING_HIGHLIGHT:string = "TickTickBoom/church_highlight";
    public static TTB_CHURCH_BUILDING_HIGHLIGHT_PIXELS:string = "TickTickBoom/church_highlight_pixels";
    public static TTB_FIRE_ANIMATION:string = "TickTickBoom/fire_";
    public static TTB_EXHAUST_ANIMATION:string = "TickTickBoom/smoke_";
    public static TTB_ENGINE_FIRE_ANIMATION:string = "TickTickBoom/carFire_";
    public static TTB_LONER_HOUSE:string = "TickTickBoom/loner_house";
    public static TTB_LONER_HOUSE_PIXELS:string = "TickTickBoom/loner_house_pixels";
    public static TTB_BUILDING_CRATER:string = "TickTickBoom/building_crater";

    //Kill The Woke
    public static KTW_INTRO_IMAGE:string = "page";
    public static KTW_CROSSHAIR:string = "crosshair";

    //Spine
    public static BIG_WIN_SPINE:string = "spine/Big_Win.json";
    public static TV_MESSAGE_SPINE:string = "spine/tv_noise.json";
    public static SCATTER_TV_SPINE:string = "spine/tvs.json";
    public static SCATTER_TV_INFECT_SPINE:string = "spine/infectiuos.json";
    public static SCATTER_ANTICIPATION_SPINE:string = "spine/Anticipation.json";
    public static MAIN_FG_SPINE:string = "spine/main_fg.json";
    public static TTB_SPINE:string = "spine/tick_tick_boom_bg.json";
    public static GOD_MODE_POPUP_SPINE:string = "spine/Pop_Up_God_Mode.json";
    public static FEATURE_INTRO_SPINE:string = "spine/tv_feature.json";
    public static SYMBOL_INFECTED_SPINE:string = "spine/infected.json";
    public static MX1_DUCK_SPINE:string = "spine/MX1.json";
    public static MX2_DUCK_SPINE:string = "spine/MX2.json";
    public static MAX_WIN_DUCK_SPINE:string = "spine/MAX.json";
    public static CLIP_DUCK_SPINE:string = "spine/CLIPS_duck.json";
    public static MX1_EXPLOSION_SPINE:string = "spine/explosion.json";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_PTW, "fonts/bitmapfonts/PTW_NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_SSD_MULTIPLIER, "fonts/bitmapfonts/NumbersMultiplier.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_SSD_MULTIPLIER_GOLD, "fonts/bitmapfonts/NumbersMultiplierGold.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_WIN_COUNT_UP_01, "fonts/bitmapfonts/NumbersWinCountUp_1.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_WIN_COUNT_UP_02, "fonts/bitmapfonts/NumbersWinCountUp_2.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_WIN_COUNT_UP_03, "fonts/bitmapfonts/NumbersWinCountUp_3.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_SSD_GREEN, "fonts/bitmapfonts/alarmclockGreen.fnt"),
                    new BitmapFontAsset(LonerGameAssets.BITMAP_FONT_SSD_RED, "fonts/bitmapfonts/alarmclockRed.fnt")
                ]
            },
            /*
            {
                name : "backgrounds",
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json")
                ]
            },

             */
            {
                name : "spine",
                assets : [
                    new SpineAsset(LonerGameAssets.TTB_SPINE, LonerGameAssets.TTB_SPINE),
                    new SpineAsset(LonerGameAssets.BIG_WIN_SPINE, LonerGameAssets.BIG_WIN_SPINE),
                    new SpineAsset(LonerGameAssets.MAIN_FG_SPINE, LonerGameAssets.MAIN_FG_SPINE),
                    new SpineAsset(LonerGameAssets.TV_MESSAGE_SPINE, LonerGameAssets.TV_MESSAGE_SPINE),
                    new SpineAsset(LonerGameAssets.SCATTER_TV_SPINE, LonerGameAssets.SCATTER_TV_SPINE),
                    new SpineAsset(LonerGameAssets.SCATTER_TV_INFECT_SPINE, LonerGameAssets.SCATTER_TV_INFECT_SPINE),
                    new SpineAsset(LonerGameAssets.SCATTER_ANTICIPATION_SPINE, LonerGameAssets.SCATTER_ANTICIPATION_SPINE),
                    new SpineAsset(LonerGameAssets.GOD_MODE_POPUP_SPINE, LonerGameAssets.GOD_MODE_POPUP_SPINE),
                    new SpineAsset(LonerGameAssets.SYMBOL_INFECTED_SPINE, LonerGameAssets.SYMBOL_INFECTED_SPINE),
                    new SpineAsset(LonerGameAssets.MX1_DUCK_SPINE, LonerGameAssets.MX1_DUCK_SPINE),
                    new SpineAsset(LonerGameAssets.MX2_DUCK_SPINE, LonerGameAssets.MX2_DUCK_SPINE),
                    new SpineAsset(LonerGameAssets.MAX_WIN_DUCK_SPINE, LonerGameAssets.MAX_WIN_DUCK_SPINE),
                    new SpineAsset(LonerGameAssets.CLIP_DUCK_SPINE, LonerGameAssets.CLIP_DUCK_SPINE),
                    new SpineAsset(LonerGameAssets.MX1_EXPLOSION_SPINE, LonerGameAssets.MX1_EXPLOSION_SPINE),
                    new SpineAsset(LonerGameAssets.FEATURE_INTRO_SPINE, LonerGameAssets.FEATURE_INTRO_SPINE)
                ]
            },
            {
                name : "main",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json")
                ],
                animations : {
                    "bullet" : "BW_Particles/Bullet/Bullet_",
                    "tooth" : "BW_Particles/Tooth/Tooth_",
                    "glowDot" : "winFrame/glowDot",
                    "glowFrame" : "winFrame/glowFrame",
                    "glowSweep" : "winFrame/glowSonarSweep",
                    "glowLine" : "winFrame/glowLineHorizontal",
                    "ptwPin1":"tv_feature/pinthewin_1",
                    "ptwPin2":"tv_feature/pinthewin_2",
                    "ptwPin3":"tv_feature/pinthewin_3",
                    "ptwPin4":"tv_feature/pinthewin_4",
                    "ptwPin5":"tv_feature/pinthewin_5",
                    "ptwPin6":"tv_feature/pinthewin_6",
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json")
                ],
                animations : {
                    "xWaysIcon" : "xWaysIcon",
                    "xSplitIcon" : "xSplitIcon"
                }
            },
            {
                name : "shootshootduck",
                assets : [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {}
            },
            {
                name : "symbolsJpeg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsJpeg0", "sheets/symbolsJpeg/symbolsJpeg0.json")
                ],
                animations : {}
            },
            {
                name : "symbolsWild",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsWild0", "sheets/symbolsWild/symbolsWild0.json")
                ],
                animations : {}
            },
            {
                name : "parts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("parts0", "sheets/parts/parts0.json")
                ],
                animations : {}
            }
        ]
    };
}